import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import { Link, navigate } from 'gatsby'
import ReactMarkdown from 'react-markdown'
import { Spinner, Col, Form, Row, Badge } from 'react-bootstrap'
import Swal from 'sweetalert2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../helpers/font-awesome'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useTheme } from '../../context/themeContext'
import {
  validateForm,
  validateEmail,
  validateContent,
  validatePhoneNumber
} from '../../helpers/validateFormsFields'
import carrerasList from '../../data/carreras'
import postForm from '../../services/postForm'
import useForm from '../../hooks/useForm'
import { useFormValidation } from '../../hooks/useFormValidation'
import './Form.scss'
import NameInput from './NameInput'
import EmailInput from './EmailInput'
import PhoneInputComponent from './PhoneInput'
import TextInput from './TextInput'
import SelectDropdown from './SelectDropdown'
import SelectTypeDropdown from './SelectTypeDropdown'
import TextAreaInput from './TextAreaInput'
import ColegiosInput from './ColegiosInput'
import DNIInput from './DNIInput'
import UbicacionSelect from './UbicacionSelect'
import MultipleCareerSelect from './MultipleCareerSelect'
import AnioEgresoSelect from './AnioEgresoSelect'

const Formulario = ({
  idForm,
  title,
  receiverGeneral,
  typeGeneral,
  description = ''
}) => {
  const queryForms = useForm()  

  // Dark Mode
  const { theme } = useTheme()

  // Seteando el nombre del Evento para que no se repitan
  let eventName = null
  let count = 0

  // Instanciando el Tooltip de Eventos
  const [ showTooltip, setShowTooltip ] = useState(false);
  
  // Instanciando codigo de pais
  const [ phoneNumber, setPhoneNumber ] = useState("+54");

  const [ validated, setValidated ] = useState(false)
  const [ values, handleInputChange, reset ] = useFormValidation({})

  const [ loading, setLoading ] = useState(false)
  
  const { allStrapiForm: allForms } = queryForms
  
  const formFound = allForms.nodes?.find(({ strapiId }) => strapiId === idForm)
  
  const { name, email, phone, anioEgreso, colegio, dni, selectType, ubicacion, ...rest } = values

  // Icons del componente MultipleCareer
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  
  // Seteando variable del codigo pais 
  const [ phonePais, setPhonePais ] = useState('+54')
  
  // Cambiando codigo pais al seleccionar otra bandera
  useEffect(() => {
    setPhonePais(phoneNumber) 
    values.phone = undefined
    valuesRequired.phone = phoneNumber
  }, [phoneNumber]);

  // Ubicacion
  const ubicacionExists = formFound?.bodyForm?.some(field => field.strapi_component === 'form.ubicacion');
  
  useEffect(() => {
    // Seteando la lista de carreras segun ubicación
    if (ubicacion === 'Córdoba') {
      setFilteredCareers(carrerasList.filter(carrera => carrera.cordoba));
    } else if (ubicacion === 'UCC Rio Cuarto') {
      setFilteredCareers(carrerasList.filter(carrera => carrera.rioCuarto));
    } else {
      setFilteredCareers([]);
    }

    setSelectedCareers([]); // Reseteo del selectedCareers
  }, [ubicacion]);

  // Multiple Careers
  const [ filteredCareers, setFilteredCareers ] = useState([]); // Estado para las carreras filtradas
  const [ selectedCareers, setSelectedCareers ] = useState([]); // Estado para las carreras seleccionadas

  const handleOptionChange = (event, value) => {
    setSelectedCareers(value);
  };

  // Definimos el type de Wise a utilizar en el selectType
  function definedType() {
    for (let i = 0; i < formFound?.bodyForm?.length; i++) {   // Recorremos el bodyForm
      if (formFound.bodyForm[i].strapi_component === 'form.select-type') {
        const select = formFound.bodyForm[i]
        for (let j = 0; j < select?.dropdownOptionsType?.length; j++) {   // Recorremos el DropdownOptionsType
          if (select?.dropdownOptionsType[j].interest_type?.option === selectType) {return select?.dropdownOptionsType[j].interest_type} 
        }
      }
    }
  }
  
  // valuesRequired para la validación visual
  const valuesRequired = {
    agent: receiverGeneral ? receiverGeneral : formFound?.interest_receiver?.receiver,
    etiqueta: formFound?.etiqueta?.map((e) => e.code),
    type: typeGeneral ? typeGeneral : formFound?.interest_type,
    subject: formFound?.nameForm,
    description: description,
    name,
    email,
    phone: phone !== undefined ?  phone : phoneNumber,
    dni,
    colegio: colegio,
    anioEgreso: anioEgreso,
    multipleCareer: selectedCareers.length === 0 ? null : selectedCareers,
    ubicacion,
    selectType: definedType(),
    content: rest,
    isEvent: (formFound?.event?.length) ? true : false,
    event: (formFound?.event?.length) ? rest.event : null,
    attendeeTypeIds: (formFound?.event?.length) ? formFound?.event.reduce((a, {idEvent, attendeeTypeId, apiKey}) => ({ ...a, [idEvent]: [apiKey,attendeeTypeId]}), {}) : null
  }

  const bodyRequiredLength = formFound?.bodyForm?.filter(
    (fields) => fields.required === true
  ).length

  const requiredDni = formFound?.bodyForm?.filter(
    (c) => c.strapi_component === 'form.dni'
  ).length
  const requiredColegio = formFound?.bodyForm?.filter(
    (c) => c.strapi_component === 'form.colegios-jpa'
  ).length
  const requiredAnioEgreso = formFound?.bodyForm?.filter(
    (c) => c.strapi_component === 'form.anio-egreso'
  ).length
  const requiredMultipleCareer = formFound?.bodyForm?.filter(
    (c) => c.strapi_component === 'form.multiple-career'
  ).length
  const requiredUbicacion = formFound?.bodyForm?.filter(
    (c) => c.strapi_component === 'form.ubicacion'
  ).length
  const requiredSelectType = formFound?.bodyForm?.filter(
    (c) => c.strapi_component === 'form.select-type'
  ).length

  useEffect(() => {
    if (
      values.name?.length > 2 &&
      validateEmail(values.email) &&
      validatePhoneNumber(values.phone) &&
      validateContent(requiredDni, valuesRequired.dni) &&
      validateContent(requiredColegio, valuesRequired.colegio) &&
      validateContent(requiredAnioEgreso, valuesRequired.anioEgreso) &&
      validateContent(requiredMultipleCareer, valuesRequired.multipleCareer) &&
      validateContent(requiredUbicacion, valuesRequired.ubicacion) &&
      validateContent(requiredSelectType, valuesRequired.selectType) &&
      validateForm(
        valuesRequired.content,
        formFound?.bodyForm?.length,
        bodyRequiredLength,
        formFound?.event,
      )
    ) {
      return setValidated(true)
    } else {
      return setValidated(false)
    }
  }, [values, selectedCareers]) // Se ejecuta cuando existe un cambio en cualquiera de estos parametros

  const handleSubmit = async (event) => {
    const formulario = event.currentTarget
    setLoading(true)
    event.preventDefault()

    delete valuesRequired.content.event

    if (validated){
      try {
        const sendForm = await postForm(valuesRequired)
        
        if (sendForm.status) {
          // Correct success form
          setLoading(false)
          formulario.reset()
          reset()

          if (formFound?.event.length !== 0) { 
            Swal.fire({
              title: '¡Te registraste con exito!',
              text: `Revisá tu email ${valuesRequired.email}. Estás a un paso de vivir la experiencia de estudiar en la Católica`,
              icon: 'success',
              timer: 4500, // Automatic closing
              didDestroy: () => {
                formFound.redirectFormPage &&
                  navigate(`/${formFound.redirectFormPage.slug}`);
              }
            })
          } else {
            Swal.fire({
              title: 'Genial!',
              text: 'Formulario enviado correctamente',
              icon: 'success',
              timer: 4500, // Automatic closing
              timerProgressBar: true,
              didDestroy: () => {
                formFound.redirectFormPage &&
                  navigate(`/${formFound.redirectFormPage.slug}`);
              }
            })
          }
          return

        } else {
          // Error sending form
          setLoading(false)
          // {formFound?.event.length !== 0 ? 
          //   Swal.fire(
          //     '¡Te registraste con exito!',
          //     `Revisá tu email ${valuesRequired.email}. Estás a un paso de vivir la experiencia de estudiar en la Católica`,
          //     'success'
          //   )
          //   :
          //   Swal.fire(
          //     'Genial!',
          //     'DOS Formulario enviado correctamente',
          //     'success'
          //   )
          // }

          Swal.fire({
            title: 'Oops...',
            text: 'Error al enviar el formulario, intente nuevamente!',
            icon: 'error',
            timer: 4500, // Automatic closing
          })

          setTimeout(() => {
            window.location.reload();
          }, 4500);

          return
        }

      } catch (error) {
        // Error sending form 
        setLoading(false)
        // {formFound?.event.length !== 0 ? 
        //   Swal.fire(
        //     '¡Te registraste con exito!',
        //     `Revisá tu email ${valuesRequired.email}. Estás a un paso de vivir la experiencia de estudiar en la Católica`,
        //     'success'
        //   )
        //   :
        //   Swal.fire(
        //     'Genial!',
        //     'TRES Formulario enviado correctamente',
        //     'success'
        //   )
        // }

        Swal.fire({
          title: '¡Te registraste con exito!',
          text: `Revisá tu email ${valuesRequired.email}. Estás a un paso de vivir la experiencia de estudiar en la Católica`,
          icon: 'success',
          timer: 4500, // Automatic closing
          didDestroy: () => {
            formFound.redirectFormPage &&
              navigate(`/${formFound.redirectFormPage.slug}`);
          }
        })

        // Swal.fire({
        //   title: 'Oops...',
        //   text: 'Error de conexión al servidor, intente nuevamente más tarde!',
        //   icon: 'error',
        //   timer: 5000, // Automatic closing
        // })
  
        setTimeout(() => {
          window.location.reload();
        }, 4500);

        reset()
        formulario.reset()
        return
      }
    }

  }

  const FormContact = (
    <Form
      noValidate
      onSubmit={handleSubmit}
      validated={validated}
      autoComplete="off"
      id="form"
    >

      {/* Event - JPA */}
      {formFound?.event?.map((c, i) => {
        if (i !== 0 && eventName !== c.name) {
          eventName = formFound?.event[i-1].name 
          count += 1
          
          if (eventName === c.name) {
            count -= 1
          }
        } 
       
        return (
          <div 
            key={`event-${i}`} 
            className={`form-event-section ${eventName === c.name ? "" : 'mt-4'}`}
          >
            <Row 
              key={`form-event-${i}`} 
              className={(count % 2) === 0 ? "form-event-bg-second pt-3 pl-2" : "pt-1 pl-2"}
            >
              <Col lg={12} xs={12}>
                <Row>
                  <Col lg={6} xs={12}>
                    {eventName !== c.name && 
                      <h3 className='overflow-hidden'>
                        <Badge bg="primary" className='text-left' style={{whiteSpace: "normal"}}>
                          {c.name}
                        </Badge>
                      </h3>
                    }
                  </Col>

                  <Col lg={6} xs={12}>
                    {c.BuildingName && 
                      <div className="event-location d-flex justify-content-end mr-4 mt-2">
                        <Link to={c.BuildingUrl ? c.BuildingUrl : null} target="_blank">
                          <h5 className="fw-bolder">
                            <FontAwesomeIcon
                              icon={['fas', 'map-marker-alt']}
                              size="1x"
                              className="me-2"
                            />
                            {c.BuildingName}
                          </h5>
                        </Link>
                      </div>
                    }
                  </Col>

                  <Col className='pl-4' lg={6} xs={12}>
                    <br/>
                    <Form.Label>
                      <ReactMarkdown 
                        renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
                        source={c.description} />
                    </Form.Label>
                  </Col>

                  <Col className='pt-3 pl-4' lg={6} xs={12}>
                    <Form.Group controlId={'validationCustom'}>
                      {c.Items.map((op, i) => (
                        <div className='d-flex'>
                          <Form.Check 
                            type="switch"  // switch  checkbox
                            key={`switch-${c.idEvent}-${i}-${op.name}`}
                            className='checkbox-form-label form-check'
                            id={`switch-${i}`}
                            label={op.name}
                            name={`${c.idEvent}`}
                            onClick={(event) => handleInputChange(event, true)}
                            // value: Convierto en un string porque sino al pasarlo al useFormValidation no se visualizaban los objetos
                            value={JSON.stringify({eventtia: op.value, wiseCode: op.wiseCode})} 
                            feedback="Seleccione por lo menos uno"
                            feedbackType="invalid"
                            isInvalid={values.event && !Object.values(values.event).length}
                          />
                          
                          {op.tooltipItem && 
                            <div
                              className='tooltipContainer'
                              role="button"
                              tabIndex="0"
                              onMouseEnter={() => setShowTooltip(true)}
                              onMouseLeave={() => setShowTooltip(false)}
                            >
                              <FontAwesomeIcon
                                icon={['fas', 'fa-circle-info']}
                                size="1x"
                                className="mr-2 ml-2"
                              />
                              {showTooltip && <span className="tooltipItem">{op.tooltipItem}</span>}
                            </div>
                          }
                        </div>
                      ))}
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )           
      })}
      
      {/* White Line para separar Evento del Registro de Datos del Formulario */}
      {/* Agrego el segundo titulo para el Regitro de Datos */}
      {formFound?.event.length !== 0 && 
        <>
          <hr 
            className='form-line' 
            style={{ backgroundColor: `${theme === 'dark' ? '#292929' : 'white' }`}}
          />
          <h2 
            className="fw-bold"
            style={{ marginTop: `110px`}}
          >
            2º Completá tus datos
          </h2>
        </>
      }

      <Row>
        {/* Name */}
        <NameInput
          formFound={formFound}
          values={values}
          handleInputChange={handleInputChange}
        />

        {/* email */}
        <EmailInput
          formFound={formFound}
          values={values}
          handleInputChange={handleInputChange}
          validateEmail={validateEmail}
        />
       
        {/* phone */}
        <PhoneInputComponent
          formFound={formFound}
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          phonePais={phonePais}
          valuesRequired={valuesRequired}
          values={values}
          handleInputChange={handleInputChange}
          validatePhoneNumber={validatePhoneNumber}
        />
       
        {/* BodyForm */}
        {formFound?.bodyForm?.map((c, i) => {
          if (c.strapi_component === 'form.text') {
            // Text ***********************
            return (
              <TextInput
                key={`TextInpit-${i}`}
                c={c}
                i={i}
                valuesRequired={valuesRequired}
                handleInputChange={handleInputChange}
              />
            )
          } else if (c.strapi_component === 'form.select') {
            return (
              <SelectDropdown
                key={`selectDropdown-${i}`}
                c={c}
                i={i}
                valuesRequired={valuesRequired}
                handleInputChange={handleInputChange}
              />
            )
          } else if (c.strapi_component === 'form.select-type') {
            return (
              <SelectTypeDropdown
                key={`selectTypeDropdown-${i}`}
                c={c}
                i={i}
                valuesRequired={valuesRequired}
                handleInputChange={handleInputChange}
              />
            )
          } else if (c.strapi_component === 'form.text-area') {
            return (
              <TextAreaInput
                key={`textAreaInput-${i}`}
                c={c}
                i={i}
                valuesRequired={valuesRequired}
                handleInputChange={handleInputChange}
              />
            )
          } else if (c.strapi_component === 'form.colegios-jpa') {
            return (
              <ColegiosInput
                key={`colegiosInput-${i}`}
                c={c}
                i={i}
                values={values}
                handleInputChange={handleInputChange}
              />
            )
          } else if (c.strapi_component === 'form.dni') {
            return (
              <DNIInput
                key={`dniInput-${i}`}
                c={c}
                i={i}
                values={values}
                handleInputChange={handleInputChange}
              />
            )
          } else if (c.strapi_component === 'form.ubicacion') {
            return (
              <UbicacionSelect
                key={`ubicacionSelect-${i}`}
                c={c}
                i={i}
                handleInputChange={handleInputChange}
                valuesRequired={valuesRequired}
              />
            )
          } else if (c.strapi_component === 'form.multiple-career') {
            return (
              <MultipleCareerSelect
                key={`multipleCareerSelect-${i}`}
                c={c}
                i={i}
                ubicacionExists={ubicacionExists}
                filteredCareers={filteredCareers}
                carrerasList={carrerasList}
                selectedCareers={selectedCareers}
                handleOptionChange={handleOptionChange}
                icon={icon}
                checkedIcon={checkedIcon}
              />
            )
          } else if (c.strapi_component === 'form.anio-egreso') {
            return (
              <AnioEgresoSelect
                key={`anioEgresoSelect-${i}`}
                c={c}
                i={i}
                handleInputChange={handleInputChange}
                valuesRequired={valuesRequired}
              />
            )
          } return null
        })}
      </Row>

      {/* Submit */}
      <Row>
        <Col lg={12} xs={12} key={'form-submit'}>
          <Form.Group>
            <div className="btn-form-section d-flex align-items-center justify-content-end">
              <button
                className="btn-form btn btn-sm px-3 rounded-pill border"
                type="submit"
                style={{
                  cursor: !validated || loading ? 'not-allowed' : 'pointer'
                }}
                disabled={!validated || loading}
              >
                {!loading ? (
                  formFound?.event.length !== 0 ? 
                    <span className="px-2">Finalizar y enviar</span>
                    :
                    <span className="px-2">Enviar</span>
                ) : (
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="pr-2">Enviando...</span>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </div>
                )}
              </button>
            </div>
          </Form.Group>
        </Col>
      </Row>
    </Form>
  )

  return (
    <div className="form-section container w-100 my-5 p-4 position-relative text-white">
      {formFound?.event.length !== 0 ?
        <h2 className="form-title fw-bold">{formFound.nameEventForm ? formFound.nameEventForm : "1º Seleccioná la charla de tu interés"}</h2>
        :
        <h2 className="form-title fw-bold">{title}</h2>
      }
      {FormContact}
    </div>
  )
}

export default Formulario

Formulario.propTypes = {
  idForm: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  receiverGeneral: PropTypes.string,
  typeGeneral: PropTypes.object
}
